module.exports = __webpack_public_path__ + "img/ewm.5c194a41.jpg";